import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import BookmarkRoundedIcon from "@mui/icons-material/BookmarkRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ChairAltRoundedIcon from "@mui/icons-material/ChairAltRounded";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import Logo from "../assets/logo.png";

const SIDEBAR_WIDTH = 260;

export default function DashboardSidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isSpacesRoute = location.pathname.startsWith("/spaces");

  const isBookSeatActive = location.pathname === "/spaces/book-seat";
  const isBookMeetingRoomActive = location.pathname === "/spaces/book-meeting-room";
  const isBookSpaceActive = location.pathname === "/spaces/book-space";

  // optional if you create /spaces page
  const isSpacesParentActive = location.pathname === "/spaces";

  const [spacesOpen, setSpacesOpen] = useState(false);

  useEffect(() => {
    if (isSpacesRoute) setSpacesOpen(true);
  }, [isSpacesRoute]);

  return (
    <Box
      sx={{
        width: SIDEBAR_WIDTH,
        height: "100vh",
        backgroundColor: "background.paper",
        borderRight: "1px solid",
        borderColor: "divider",
        position: "sticky",
        top: 0
      }}
    >
      <Box sx={{ textAlign: "center", py: 2 }}>
        <Box
          component="img"
          src={Logo}
          alt="NeherBaari Logo"
          sx={{ width: 190, height: "auto", mx: "auto", display: "block" }}
        />
      </Box>

      <Divider />

      <Box sx={{ px: 2, mt: 2 }}>
        <List disablePadding>
          {/* Home */}
          <ListItemButton selected={location.pathname === "/"} onClick={() => navigate("/")}>
            <ListItemIcon>
              <HomeRoundedIcon />
            </ListItemIcon>
            <ListItemText
              primary="Home"
              primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
            />
          </ListItemButton>

          {/* Spaces */}
          <Box
            onMouseEnter={() => setSpacesOpen(true)}
            onMouseLeave={() => {
              if (!isSpacesRoute) setSpacesOpen(false);
            }}
            sx={{ mt: 0.6 }}
          >
            <ListItemButton
              selected={isSpacesParentActive}
              onClick={() => navigate("/spaces/book-seat")}
              sx={{ pr: 1.2 }}
            >
              <ListItemIcon>
                <ChairAltRoundedIcon />
              </ListItemIcon>

              <ListItemText
                primary="Spaces"
                primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
              />

              <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
                {spacesOpen ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
              </Box>
            </ListItemButton>

            <Collapse in={spacesOpen} timeout={160} unmountOnExit>
              <List disablePadding sx={{ mt: 0.6, pl: 4 }}>
                <ListItemButton
                  selected={isBookSeatActive}
                  onClick={() => navigate("/spaces/book-seat")}
                  sx={{ mt: 0.6 }}
                >
                  <ListItemText
                    primary="Book a Seat"
                    primaryTypographyProps={{ fontSize: 15, fontWeight: 700 }}
                  />
                </ListItemButton>

                <ListItemButton
                  selected={isBookMeetingRoomActive}
                  onClick={() => navigate("/spaces/book-meeting-room")}
                  sx={{ mt: 0.6 }}
                >
                  <ListItemText
                    primary="Book a Meeting Room"
                    primaryTypographyProps={{ fontSize: 15, fontWeight: 700 }}
                  />
                </ListItemButton>

                <ListItemButton
                  selected={isBookSpaceActive}
                  onClick={() => navigate("/spaces/book-space")}
                  sx={{ mt: 0.6 }}
                >
                  <ListItemText
                    primary="Book the Space"
                    primaryTypographyProps={{ fontSize: 15, fontWeight: 700 }}
                  />
                </ListItemButton>
              </List>
            </Collapse>
          </Box>

          {/* My Bookings */}
          <ListItemButton
            selected={location.pathname.startsWith("/bookings")}
            onClick={() => navigate("/bookings")}
            sx={{ mt: 0.6 }}
          >
            <ListItemIcon>
              <BookmarkRoundedIcon />
            </ListItemIcon>
            <ListItemText
              primary="My Bookings"
              primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
            />
          </ListItemButton>

          {/* Events */}
          <ListItemButton
            selected={location.pathname.startsWith("/events")}
            onClick={() => navigate("/events")}
            sx={{ mt: 0.6 }}
          >
            <ListItemIcon>
              <CalendarMonthRoundedIcon />
            </ListItemIcon>
            <ListItemText
              primary="Events"
              primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
            />
          </ListItemButton>

          {/* Settings */}
          <ListItemButton
            selected={location.pathname.startsWith("/settings")}
            onClick={() => navigate("/settings")}
            sx={{ mt: 0.6 }}
          >
            <ListItemIcon>
              <SettingsRoundedIcon />
            </ListItemIcon>
            <ListItemText
              primary="Settings"
              primaryTypographyProps={{ fontSize: 16, fontWeight: 700 }}
            />
          </ListItemButton>
        </List>
      </Box>
    </Box>
  );
}

export { SIDEBAR_WIDTH };
